import { Settings, VehicleSize } from '../types/booking'

export const vehicleSizes: VehicleSize[] = [
  { id: 'compact', label: 'Compact', note: 'Polo, Corsa, Aygo', surchargePct: 0 },
  { id: 'sedan', label: 'Middenklasse', note: 'Golf, A4, 3-serie', surchargePct: 10 },
  { id: 'suv', label: 'SUV', note: 'Tiguan, X5, Kodiaq', surchargePct: 20 },
  { id: 'van', label: 'Bus / MPV', note: 'Transit, Vito, Touran', surchargePct: 30 },
]

export const weekdayLabels = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag']

export const defaultSettings: Settings = {
  hours: [
    { open: null, close: null },
    { open: '09:00', close: '18:00' },
    { open: '09:00', close: '18:00' },
    { open: '09:00', close: '18:00' },
    { open: '09:00', close: '18:00' },
    { open: '09:00', close: '18:00' },
    { open: '09:00', close: '16:00' },
  ],
  slotStepMinutes: 30,
  bays: 2,
  leadTimeHours: 12,
  depositPct: 25,
  blockedDates: [],
}
